import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
import messages from './langs';

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.lang || 'cn',
  messages,
});
locale.i18n((key, value) => i18n.t(key, value)); //重点：为了实现element插件的多语言切换

// 非 vue 文件中使用这个方法
const translate = (localeKey) => {
  const locale = localStorage.getItem("lang") || "cn"
  const hasKey = i18n.te(localeKey, locale)  // 使用i18n的 te 方法来检查是否能够匹配到对应键值
  const translatedStr = i18n.t(localeKey)
  if (hasKey) {
    return translatedStr
  }
  return localeKey
}

export { i18n, translate };
